export const EVENT_FAQ_ORDER = [
  'createEvent',
  'whatIfCantHostEvent',
  'payouts',
  'refunds',
  'buyTicket',
  'addParticipantsManual',
  'reminders',
  'cannotBuy',
  'cannotOpenPrivatePage',
  'cannotJoin',
  'blockParticipant',
  'testAsAttendee',
  'capacityFull',
  'changeAddress',
  'supportedDevices',
  'addCoHost',
  'messageAll',
  'statsPage',
  'managementPage',
  'participantsPage',
  'privatePage',
  'publicPage',
  'ticketsPage',
  'profitPage',
  'productsPage',
  'certificatesPage',
  'integrationsPage',
  'zapierIntegration',
  'csvIntegration',
  'addonsPage',
  'settingsPage',
] as const

export type EventFaqKey = (typeof EVENT_FAQ_ORDER)[number]
